import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/cemetery/:slug',
    alias: '/c/:slug',
    name: 'cemetery',
    component: () => import('../views/CemeteryView.vue')
  },
  {
    path: '/person',
    name: 'person',
    component: () => import('../views/PersonView.vue')
  },
  {
    path: '/available/:slug',
    alias: '/a/:slug',
    name: 'available',
    component: () => import('../views/AvailableSpacesView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name : 'notfound',
    component: () => import('@/views/NotFoundView.vue')
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
